import { getFromBreakpoint } from '@vakantiesnl/components/src/styles/breakpoints';
import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useCustomStyles = makeStyles()((theme) => ({
	title: {
		color: theme.body.foreground.color.default,
		paddingBottom: theme.spacing.small,
	},
	priceTable: {
		display: 'flex',
		flex: '1 0 auto',
		flexDirection: 'column',
		borderCollapse: 'collapse',
		width: '100%',

		'& th': {
			textAlign: 'left',
		},
		'& td': {
			color: theme.body.foreground.color.default,
		},
	},
	tableBody: {
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing.xxsmall,
		paddingBottom: theme.spacing.small,
		borderBottom: theme.divider.border,

		'& tr': {
			display: 'flex',
			justifyContent: 'space-between',
			alignItems: 'center',
		},
	},
	roomTableBody: {
		paddingBottom: theme.spacing.small,
		marginBottom: theme.spacing.small,
		borderBottom: theme.divider.border,
	},
	discountTableBody: {
		marginTop: theme.spacing.small,
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing.xxsmall,
		paddingBottom: theme.spacing.small,
		borderBottom: theme.divider.border,

		'& tr': {
			display: 'flex',
			justifyContent: 'space-between',
			alignItems: 'center',
		},
	},
	totalPriceRow: {
		marginTop: theme.spacing.xxsmall,
		display: 'flex',
		alignItems: 'end',
		justifyContent: 'space-between',

		[getFromBreakpoint('lg')]: {
			marginBottom: theme.spacing.medium,
		},
	},
}));
